<h1>References</h1>
<h2>Czech Baseball Association - Baseball Czech TV (Staylive PPV)</h2>
<p>
  As the Czech Baseball Association, we have been using Ball Score since 2021 and can only recommend it. It has
  significantly helped us to move the streaming of Czech baseball forward. We have unified the visual of the overall
  production of the Extraliga streams as a long-term competition. It also helped us to unify the visuals of streams from
  events like Prague Baseball Week, All Star Game and Eurobaseball.
</p>
<p>
  <b>Lukáš Ercoli</b><br />
  <i>Marketing and Communications Director of the CBA</i>
</p>
<!--

<h2>Czech Television - public television broadcaster</h2>
<p>
  Integrating Ball Score into our production workflow helped us to present information to viewers without the need of
  hours of preparation. The solution was very responsive and met all standard criteria we needed for Eurobaseball
  in fall of 2023 and Prague Baseball Tournament in July of 2024.
</p>
<p>
  <b>Kamila Šleisová</b><br />
  <i>Production manager</i>
</p>

<h2>O2TV - independent television broadcaster</h2>
<p>
  We used Ball Score during a recent production of Czech Extraliga All Star Game in June 2024, it saved us big amount
  of resources and the graphic quality was comparable with graphics in MLB games we broadcast to our client.
</p>
<p>
  <b></b><br />
  <i>Production manager</i>
</p>
-->
